import { Fragment, useState } from "react";
import BTDialogBox from "../../components/BTDialgBox";
import BTTypography from "../../components/BTTypography";
import { CircularProgress } from "@mui/material";
import { useNotification } from "../../context";
import { Notifications } from "@mui/icons-material";
import authService from "../../services/auth-service";
import { manage_store_data } from "../../store/functions";
const Addungraded = ({ row, setUngraded, setRefresh }) => {
  const { addNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const handleDelete = async () => {
    try {
      setLoading(true);
      const response = await authService?.ungraded_submit_return({
        attributes: row,
      });
      if (response?.status === 1) {
        const { stn_submits } = response?.data;
        manage_store_data({
          name: "submissions",
          data: stn_submits,
          type: "update",
          key: "stn_id",
          total: null,
        });
        addNotification({
          icon: <Notifications color="white" />,
          title: "Successfully",
          message: response?.message,
          color: "success",
        });
        setRefresh((prev) => !prev);
        setLoading(false);
        handleClose();
      }
    } catch (error) {
      setLoading(false);
      addNotification({
        icon: <Notifications color="white" />,
        title: "Error!",
        message: "Somthing Went Wrong!",
        color: "error",
      });
    }
  };
  const handleClose = () => {
    setUngraded(null);
  };
  return (
    <BTDialogBox
      open={Boolean(row)}
      width="500px"
      maxWidth="md"
      minHeight={"50px"}
      close={handleClose}
      title="Ungraded confirmation"
      buttons={[
        {
          name: "Cancel",
          color: "secondary",
          size: "small",
          onClick: handleClose,
        },
        {
          name: "Ungraded",
          variant: "gradient",
          color: "dark",
          size: "small",
          onClick: handleDelete,
          loading: loading,
          loadingComponent: (
            <Fragment>
              <svg width={0} height={0}>
                <defs>
                  <linearGradient
                    id="my_gradient"
                    x1="0%"
                    y1="0%"
                    x2="0%"
                    y2="100%">
                    <stop offset="0%" stopColor="#e01cd5" />
                    <stop offset="100%" stopColor="#1CB5E0" />
                  </linearGradient>
                </defs>
              </svg>
              <CircularProgress
                size={22}
                sx={{
                  "svg circle": { stroke: "url(#my_gradient)" },
                }}
              />
            </Fragment>
          ),
          sx: { ml: 2, width: "80px" },
        },
      ]}>
      <BTTypography variant="body2" fontWeight={"light"}>
        Are you sure to ungraded this record ?
      </BTTypography>
    </BTDialogBox>
  );
};
export default Addungraded;
